<script>
import { SLIDE_DURATION_MS } from '@base/stories/const'

export default {
  name: 'story-status-bar',
  props: {
    barIdx: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 1,
    },
    duration: {
      type: Number,
      default: SLIDE_DURATION_MS,
    },
    isPaused: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<template>
  <div class="story-status-bar">
    <div
      v-for="index in length"
      class="story-status-bar__item"
      :style="`--animation-duration: ${duration}ms`"
      :class="{
        'story-status-bar__item--watched': index - 1 < barIdx,
        'story-status-bar__item--active': index - 1 === barIdx,
        'story-status-bar__item--paused': isPaused,
      }"
    />
  </div>
</template>

<style lang="sass" scoped>
.story-status-bar
  display: flex
  flex-direction: row
  gap: 8px

  &__item
    position: relative
    height: 3px
    width: 100%
    border-radius: 1px
    background: rgba(255, 255, 255, 0.3)

    &::before
      position: absolute
      background: white
      content: ""
      inset-block: 0
      inset-inline-start: 0

    &--active::before
      animation-name: story-status-bar
      animation-duration: var(--animation-duration)
      animation-timing-function: linear
      animation-iteration-count: 1

    &--watched::before
      width: 100%

    &--active.story-status-bar__item--paused::before
      animation-play-state: paused

@keyframes story-status-bar
  0%
    width: 0%

  100%
    width: 100%
</style>



// WEBPACK FOOTER //
// src/templates/components/base/stories/StoryStatusBar.vue